import { Box, Flex, Input, Text } from "@chakra-ui/react";

import DiaItem from "./DiaItem";
import { ParceiroDisponibilidadeItem } from "core/features/parceiros/typings/index";

export const days = [0, 1, 2, 3, 4, 5, 6];
export const weekdays = [
  "Domingo",
  "Segunda",
  "Terça",
  "Quarta",
  "Quinta",
  "Sexta",
  "Sábado",
];

const items = days.map((day) => ({
  dia: day,
}));

function RangeDates({
  value,
  onChange,
}: {
  value: ParceiroDisponibilidadeItem[];
  onChange: (v: ParceiroDisponibilidadeItem[]) => void;
}) {
  value = value || [];

  const checkDaySelected = (dia: number) => {
    const a = value || [];
    const exists = a.findIndex((day) => day.dia === dia);

    return exists !== -1;
  };

  const handleChange = (
    prop: keyof ParceiroDisponibilidadeItem,
    v: any,
    dia?: number
  ) => {
    if (dia === undefined) {
      return;
    }

    const newValue = [...value];

    const index = newValue.findIndex((v) => v.dia === dia);

    if (index > -1) {
      const newItem = { ...newValue[index], [prop]: v };
      newValue.splice(index, 1, newItem);
    }

    onChange(newValue);
  };

  const getDiaValue = (
    values: ParceiroDisponibilidadeItem[],
    dia: number
  ): ParceiroDisponibilidadeItem | undefined => {
    const value = values.find((v) => v.dia === dia);

    return value;
  };

  return (
    <Flex mb="16px" w="100%" gap="8px">
      {items.map((item) => {
        return (
          <Flex key={item.dia} flex={1} flexDir={"column"}>
            <Box>
              <DiaItem
                selected={checkDaySelected(item.dia)}
                onClick={() => {
                  const exists = checkDaySelected(item.dia);

                  if (exists) {
                    const nextValue = value.filter(
                      ({ dia }) => dia !== item.dia
                    );

                    onChange(nextValue);
                  } else {
                    const nextValue = [
                      ...(value ?? []),
                      { dia: item.dia, horaInicio: "00:00", horaFim: "23:59" },
                    ];
                    onChange(nextValue);
                  }
                }}
              >
                {weekdays[item.dia]}
              </DiaItem>
            </Box>

            {checkDaySelected(item.dia) ? (
              <Flex mt="24px" gap="16px" flexDir={"column"}>
                <Box>
                  <Text>Início</Text>
                  <Input
                    value={getDiaValue(value, item.dia)?.horaInicio ?? ""}
                    onChange={(ev) => {
                      handleChange("horaInicio", ev.target.value, item.dia);
                    }}
                    type="time"
                  />
                </Box>
                <Box>
                  <Text>Fim</Text>
                  <Input
                    min={getDiaValue(value, item.dia)?.horaInicio ?? ""}
                    value={getDiaValue(value, item.dia)?.horaFim ?? ""}
                    onChange={(ev) => {
                      handleChange("horaFim", ev.target.value, item.dia);
                    }}
                    type="time"
                  />
                </Box>
              </Flex>
            ) : null}
          </Flex>
        );
      })}
    </Flex>
  );
}

export default RangeDates;
